import type { ReactNode } from "react";

import { PageHeader } from "../../components/WorkspacePrimitives";
import type { AgentCompany } from "../api/e2e";
import CompanyContextNavigation from "./CompanyContextNavigation";
import CompanyTabs from "./CompanyTabs";

export default function CompanyWorkspaceHeader({
  companies,
  company,
  actions,
}: {
  companies: readonly AgentCompany[];
  company: AgentCompany;
  actions?: ReactNode;
}) {
  return (
    <PageHeader className="company-workspace-header">
      <CompanyContextNavigation
        companies={companies}
        company={company}
        backTo="/companies"
        backLabel="Companies"
        actions={actions}
      />
      <CompanyTabs companyId={company.id} />
    </PageHeader>
  );
}
